import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import CatalogoClientes from "../../../views/Comercial/CatalogoClientes/CatalogoClientes";
import ClientesForm from "../../../views/Comercial/CatalogoClientes/Componentes/ClientesForm";
import CatalogoProveedores from '../../../views/Comercial/CatalogoProveedores/CatalogoProveedores';
import SumaLanding from '../../../views/Comercial/SumaLanding/SumaLanding';
import ParaFacturacion from '../../../views/Comercial/ParaFacturacion/ParaFacturacion';
const Comercial = () => {
    return (
        <Routes>
            <Route exact path="/comercial/catalogo-clientes" element={
                <Suspense fallback={<>skeleton</>}>
                    <CatalogoClientes />
                </Suspense>
            }>
            </Route>
            <Route exact path="/comercial/catalogo-clientes/:id" element={
                <Suspense fallback={<>skeleton</>}>
                    <ClientesForm />
                </Suspense>
            }>
            </Route>
            <Route exact path="/comercial/catalogo-clientes/nuevo" element={
                <Suspense fallback={<>skeleton</>}>
                    <ClientesForm />
                </Suspense>
            }>
            </Route>
            <Route exact path="/comercial/catalogo-proveedores" element={
                <Suspense fallback={<>skeleton</>}>
                    <CatalogoProveedores />
                </Suspense>
            }>
            </Route>
            <Route exact path="/comercial/suma-landing" element={
                <Suspense fallback={<>skeleton</>}>
                    <SumaLanding />
                </Suspense>
            }>
            </Route>
            <Route exact path="/administracion/para-facturacion" element={<Suspense fallback={<>skeleton</>}>
                <ParaFacturacion></ParaFacturacion>
            </Suspense>} />
        </Routes>
    )
}

export default Comercial